export default __webpack_public_path__ + "static/media/Banner1.2f4c65a2.png";